import React                  from 'react'
import Img                    from "gatsby-image"
import { map }                from 'lodash-es'
import cx                     from 'utils/classnames'
import Icon                   from 'entrada-ui/Icon'
import ChevronSvg             from './chevron.svg'
import styles                 from './styles.module.scss'

const Slideshow = (props) => {
  const {
    className,
    // If true, then no transition will happen.
    noTransition = false,
    // Time it takes (milliseconds) before next transition starts
    duration = 5000,
    // Determines how long the transition takes
    transitionDuration = 300,
    ViewProps = {},
    showIndicators = true,
    children
  } = props

  const [currentIdx, setCurrentIdx] = React.useState(0)
  const transitionTimer = React.useRef(false)

  const goToSlide = (idx) => {
    clearTimeout(transitionTimer.current)
    setCurrentIdx(idx)
  }

  React.useEffect(() => {
    transitionTimer.current = setTimeout(() => {
      if(!noTransition) {
        setCurrentIdx(currentIdx === children.length - 1 ? 0 : currentIdx + 1)
      }
    }, duration)

    return () => clearTimeout(transitionTimer.current)
  }, [children.length, duration, currentIdx, noTransition])

  const onClickLeft = () => goToSlide(currentIdx === 0 ? children.length - 1 : currentIdx - 1)
  const onClickRight = () => goToSlide(currentIdx === children.length - 1 ? 0 : currentIdx + 1)

  return (
    <div
      className={cx(styles.slideshow, className)}
    >
      <div className={cx(styles.view, ViewProps.className)} style={{
        transition: noTransition ? 'none' : `transform ease-in ${transitionDuration}ms`,
        transform:  noTransition ? 'none' : `translateX(-${currentIdx * 100}%)`
      }}>
        {children}
      </div>

      {showIndicators &&
      <Slideshow.Indicators slides={children} current={currentIdx} onChange={setCurrentIdx} />
      }

      {!noTransition &&
      <button className={cx(styles.btn, styles.left)} onClick={onClickLeft}>
        <img src={ChevronSvg} />
      </button>
      }

      {!noTransition &&
      <button className={cx(styles.btn, styles.right)} onClick={onClickRight}>
        <img src={ChevronSvg} />
      </button>
      }
    </div>
  )
}

Slideshow.Slide = ({ className, ...props}) => <div className={cx(styles.slide, className)} {...props} />

Slideshow.Indicators = ({ slides, current, onChange }) => (
  <ul className={styles.indicators}>
      {map(slides, (s, idx) => (
        <li className={cx(styles.indicator, current === idx && styles.active)} key={idx} onClick={() => onChange(idx)} />
      ))}
  </ul>
)

Slideshow.Img = ({ className, ...props}) => (
  <Img className={cx(styles.img, className)} {...props} />
)

export default Slideshow
